<template>
    <b-card no-body>
        <b-overlay :show="loading" opacity="0.2" rounded="sm" class="p-2">
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label ">Döviz Kuru</label>
                    <div class="row g-50 currency-container justify-content-center justify-content-md-start w-100 no-gutters">
                        <div class="col-auto" v-for="(item,index) in currencies" :key="index">
                            <div class="currency rounded border px-1 py-50" v-on:click="currency = item.key; getCurrencies()" :class="item.key == currency ? 'active':null">
                                {{item.key}} <b v-html="item.symbol"></b>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="form-label">Bilgi Kaynağı</label>
                    <div>
                        <b-form-radio v-for="(item,index) in sources" :id="item.id" inline :key="index" v-model="source" v-on:change="getCurrencies" :value="item.key">{{item.name}}</b-form-radio>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="(info,index) in c_infos" :key="index" class="col-md-6 mt-1">
                    <div class="border rounded p-1">
                        <div class="row">
                            <div class="col-md-auto mb-1 mb-md-0">
                                <span class="currency-info-text">1 {{info.currency}} eşittir</span>
                                <h1 class="font-weight-bolder my-25">{{info.rate}} <span v-html="c_currentCurrencySymbol"></span></h1>
                                <span class="currency-info-text">{{info.lastSyncTime}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <currency-rates-last-month :data="info.Last30Days"></currency-rates-last-month>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import {BCard,BFormRadio,BOverlay} from 'bootstrap-vue'
import randomatic from 'randomatic'
import CurrencyApi from '@/api/currency'
import CurrencyRatesLastMonth from './components/CurrencyRatesLastMonth'
export default {
    components:{
        BCard,
        BFormRadio,
        BOverlay,
        CurrencyRatesLastMonth
    },
    data(){
        return {
            currencies:[
                {id:randomatic('A0',10),key:'TRY',symbol:"&#8378;"},
                {id:randomatic('A0',10),key:'USD',symbol:"&#36;"},
                {id:randomatic('A0',10),key:'EUR',symbol:"&#8364;"},
            ],
            currency:"TRY",
            sources:[
                { id:randomatic('A0',10),key:'TCMB',name:"TCMB"},
                { id:randomatic('A0',10),key:'CurrencyRateApiDotCom',name:"Piyasa Kuru"},
            ],
            source:"TCMB",
            infos:{},
            loading:false,
        }
    },
    mounted(){
        this.getCurrencies()
    },
    methods:{
        getCurrencies(){
            this.loading = true
            CurrencyApi.Info({SourceCurrencyCode:this.currency,FromSource:this.source}).then(res=>{
                this.infos = res.data.Data
                this.loading = false
            }).catch(err=>{
                this.loading = false
            })
        },
    },
    computed:{
        c_currentCurrencySymbol(){
            return this.currencies.find(item=>item.key == this.currency).symbol
        },
        c_infos(){
            if(Object.keys(this.infos).length){
                let infos = [
                    {
                        currency:"TRY",
                        rate : this.infos.CurrencyRatesInformation.TRY,
                        lastSyncTime : this.infos.CurrencyRatesInformation.LastSyncTime,
                        symbol: this.currencies.find(item=>item.key=="TRY").symbol,
                        Last30Days : this.infos.Last30DaysStats.map(st=>{
                            return{
                                date:st.Date,
                                rate:st.TRYAvg
                            }
                        })
                    },
                    {
                        currency:"USD",
                        rate : this.infos.CurrencyRatesInformation.USD,
                        lastSyncTime : this.infos.CurrencyRatesInformation.LastSyncTime,
                        symbol: this.currencies.find(item=>item.key=="USD").symbol,
                        Last30Days : this.infos.Last30DaysStats.map(st=>{
                            return{
                                date:st.Date,
                                rate:st.USDAvg
                            }
                        })
                    },
                    {
                        currency:"EUR",
                        rate : this.infos.CurrencyRatesInformation.EUR,
                        lastSyncTime : this.infos.CurrencyRatesInformation.LastSyncTime,
                        symbol: this.currencies.find(item=>item.key=="EUR").symbol,
                        Last30Days : this.infos.Last30DaysStats.map(st=>{
                            return{
                                date:st.Date,
                                rate:st.EURAvg
                            }
                        })
                    }
                ]
                return infos.filter(i=> i.currency != this.currency)
            }else return []
        },
    }
}
</script>

<style>
    .currency{
        cursor: pointer;
        font-weight: bold;
    }
    .currency.active{
        border-color: var(--primary) !important;
        background-color: rgba(31, 70, 144, 0.12);
        color: var(--primary);
        box-shadow: 0px 0px 0px 1px var(--primary);
    }

    .dark-layout .currency.active{
        border-color: white !important;
        color:white;
        background-color: rgba(255, 255, 255, 0.12);
        
        box-shadow: 0px 0px 0px 1px white;
    }
    .currency-info-text{
        font-size: 0.85rem;
        opacity: 0.85;
    }
</style>